export default "__VITE_ASSET__I1PHjuSV__"